(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/b2b-ui/helper/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/b2b-ui/helper/helpers/handlebars-helpers.js');

var isServerSide = typeof exports === 'object';
var componentHelper;

if (isServerSide) {
  var trinidad = require('@svenskaspelab/trinidad-core').core;
  componentHelper = trinidad.components.require('utils', 'component-helper')
    .api;

  registerHelpers(require('hbs'));
} else {
  componentHelper = svs.utils.component_helper.helper;
  registerHelpers(Handlebars);
}

function registerHelpers(hbs) {
  hbs.registerHelper('b2b-ui', function() {
    return componentHelper.apply(this, [
      arguments,
      isServerSide ? 'b2b_ui' : svs.b2b_ui
    ]);
  });
}


 })(window);